import HardPullDeclineAndCreditFrozenScreen from 'features/lineOfCredit/screens/hardPullDeclineAndCreditFrozen/HardPullDeclineAndCreditFrozenScreen';
import React from 'react';

export default function Page() {
  return <HardPullDeclineAndCreditFrozenScreen />;
}
